import React from 'react';
import { Sparkles } from 'lucide-react';

const Header = () => {
  return (
    <div className="text-center mb-12 pt-8">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 rounded-2xl mb-6 shadow-2xl shadow-purple-500/25 transform hover:scale-105 transition-transform duration-300">
        <Sparkles className="w-10 h-10 text-white animate-pulse" />
      </div>
      <h1 className="text-6xl font-bold bg-gradient-to-r from-cyan-300 via-purple-300 to-pink-300 bg-clip-text text-transparent mb-4 tracking-tight">
        Drive-Thru AI
      </h1>
      <p className="text-xl text-gray-300 font-light">Voice-powered order processing for fast food restaurants</p>
    </div>
  );
};

export default Header; 